export default {
  groupName: 'investor-services-demo',
  appName: 'Investor Services Demo',
  baseRoute: '/dashboard/investor-services-demo',
  label: 'Template Dashboard',
  home: '/slicer',
  image: 'demo.png',
  description: 'Template Advertising Dashboard'
}
